<template>
  <div>
    <!-- 会员权益 -->
    <div class="powerConfig">
      <h4 class="describe">会员权益</h4>
      <div class="configWrap">
        <h6 class="tips">权益配置</h6>
        <ul class="navList">
          <li
            class="nav"
            :class="{ active: navSelect == item.id }"
            v-for="item in navList"
            :key="'nav' + item.id"
            @click="(navSelect = item.id), switchPowerItem(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- 配置表格 -->
        <div class="configTable">
          <div class="configTh">
            <span style="flex: 3">名称</span>
            <span style="flex: 1">图标</span>
            <span style="flex: 1">排序</span>
            <span style="flex: 1">操作</span>
          </div>

          <div
            class="configItem"
            v-for="(item, index) in pageConfig.menberPage.powerList"
            :key="'confingItem' + index"
            @click="click(item)"
          >
            <div class="edit">
              <el-input class="ipt" v-model="item.name"></el-input>
              <div class="icons">
                <img :src="item.imageUrl" @click="selectPicture(item)" />
              </div>
              <div class="sort">
                <i
                  class="iconfont"
                  :class="{ disabled: index == 0 }"
                  @click="movePower({ id: item.id, type: 'moveUp' })"
                  >&#xe691;</i
                >
                <i
                  class="iconfont"
                  :class="{
                    disabled:
                      index == pageConfig.menberPage.powerList.length - 1,
                  }"
                  @click="movePower({ id: item.id, type: 'moveDown' })"
                  >&#xe690;</i
                >
              </div>
              <span class="delete" @click="deletePower(item.id)">删除</span>
            </div>
            <div class="link">
              <el-input class="linkIpt" v-model="item.link"></el-input>
              <i
                class="jumpLink iconfont"
                @click="checkCurLinkItem(item), (linkAdminVisible = true)"
                >&#xe693;</i
              >
            </div>
          </div>
          <!-- 添加项 -->
          <p class="handle">
            <span class="add" @click="addPowerItem">添加一项</span>
            <span>最少1项，最多8项</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 图片库 -->
    <PhotoGallery
      :isShow="photoGalleryVisible"
      @close="photoGalleryChange"
    ></PhotoGallery>
    <!-- 链接管理 -->
    <LInkAdmin :isShow="linkAdminVisible" @close="linkAdminChange"></LInkAdmin>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PhotoGallery from "@/components/PhotoGallery";
import LInkAdmin from "@/components/LInkAdmin";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectPictureMiXin from "@/mixin/selectPictureMiXin";

export default {
  components: {
    PhotoGallery,
    LInkAdmin,
  },
  data() {
    return {
      navList: [
        { name: "潜在", id: 0 },
        { name: "一星", id: 1 },
        { name: "二星", id: 2 },
        { name: "三星", id: 3 },
        { name: "四星", id: 4 },
        { name: "五星", id: 5 },
      ],
      navSelect: 0,
      checkbox: false,
      photoGalleryVisible: false,
      linkAdminVisible: false,
      curSelectItem: null,
    };
  },
  computed: {
    ...mapState(["pageConfig"]),
  },
  created() {
    // this.switchPowerItem(0)
  },
  mixins: [selectPictureMiXin],
  methods: {
    click(item) {
      console.log(item);
    },
    ...mapMutations([
      "movePower",
      "addPowerItem",
      "replaceIcon",
      "deletePower",
      "checkCurLinkItem",
      "editItemLink",
      "switchPowerItem",
    ]),
    // 选择链接后返回
    linkAdminChange(data) {
      this.linkAdminVisible = false;
      if (data) {
        //有数据返回
        this.editItemLink(data);
      }
    },
    querymember() {
      querymemberLevel().then((res) => {
        if (res.data[0]) {
          this.navList[1].name = res.data[0].customerLevelName;
        } else {
          this.navList[1].name = "";
        }
        if (res.data[1]) {
          this.navList[2].name = res.data[1].customerLevelName;
        } else {
          this.navList[2].name = "";
        }
        if (res.data[2]) {
          this.navList[3].name = res.data[2].customerLevelName;
        } else {
          this.navList[3].name = "";
        }
        if (res.data[3]) {
          this.navList[4].name = res.data[3].customerLevelName;
        } else {
          this.navList[4].name = "";
        }
        if (res.data[4]) {
          this.navList[5].name = res.data[4].customerLevelName;
        } else {
          this.navList[5].name = "";
        }
        // res.data.length;
        this.navList.splice(res.data.length + 1, 5);
      });
    },
  },
  mounted() {
    this.querymember();
  },
};
</script>

<style lang="scss" scoped>
.powerConfig {
  .describe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 28px;
    margin: 0;
    text-align: left;
    height: 64px;
    background-color: #f5f5f5;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    .desc {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .configWrap {
    box-sizing: border-box;
    padding: 20px 28px;
    // height: calc(100% - 64px);
    text-align: left;
    border-bottom: 1px solid #f3f3f3;
    .tips {
      position: relative;
      display: inline-block;
      color: #333;
      font-size: 14px;
      font-weight: 500;
      &::after {
        content: "*";
        position: absolute;
        right: -8px;
        top: 2px;
        color: #ff3a27;
      }
    }
    .navList {
      display: flex;
      align-items: center;
      margin-top: 12px;
      .nav {
        flex: 1;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 2px;
        border: 1px solid #dddddd;
        color: #666666;
        font-size: 14px;
        font-weight: 400;
        border-radius: 2px 2px 0px 0px;
        transition: all 0.2s;
        cursor: pointer;
        &:last-child {
          margin: 0;
        }
        &.active {
          border-radius: 3px 3px 0px 0px;
          border-top: 2px solid #fe4d45;
          border-bottom: none;
        }
      }
    }
    .configTable {
      margin-top: 20px;
      max-height: 600px;
      overflow: scroll;
      &.centerMove-enter-active {
        transition: all 1s;
        &::-webkit-scrollbar-thumb {
          background: #ddd;
        }
      }
      &::-webkit-scrollbar {
        display: none;
      }
      &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #f5f7fa;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
      }
      .configTh {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 30px;
        height: 50px;
        background-color: #fafafa;
        span {
          color: #333;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .configItem {
        box-sizing: border-box;
        padding: 16px 30px 20px;
        border-bottom: 1px solid #f3f3f3;
        .edit {
          display: flex;
          align-items: center;
          .ipt {
            flex: 3;
            height: 32px;
            /deep/ .el-input__inner {
              width: 90%;
              height: 32px;
            }
          }
          .icons {
            flex: 1;
            img {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              cursor: pointer;
            }
          }
          .sort {
            flex: 1;
            i {
              cursor: pointer;
              &.disabled {
                color: #dddddd;
                cursor: no-drop;
              }
            }
          }
          .delete {
            flex: 1;
            cursor: pointer;
            color: #7f85e9;
            font-size: 14px;
            font-weight: 400;
          }
        }
        .link {
          position: relative;
          margin-top: 16px;
          .jumpLink {
            position: absolute;
            right: 1px;
            top: 1px;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #eeeeee;
            cursor: pointer;
          }
          .linkIpt {
            height: 32px;
            /deep/ .el-input__inner {
              height: 32px;
            }
          }
        }
      }
      .handle {
        box-sizing: border-box;
        padding-left: 30px;
        margin-top: 16px;
        color: #999;
        font-size: 13px;
        font-weight: 400;
        .add {
          display: inline-block;
          margin-right: 12px;
          cursor: pointer;
          color: #7f85e9;
        }
      }
    }
  }
}
</style>
